import React from 'react';
var AppContext = React.createContext({
  modalContainer: null,
  onUpdateChartSettings: function onUpdateChartSettings() {},
  keenClient: {},
  disableFilterSuggestions: false
});
export default AppContext;